import angular from 'angular';

import Login from './login/login';
import NotFound from './404/notfound';

import Admin from './admin/admin';
import Profile from './profile/profile';
import Timesheet from './timesheet/timesheet';
import Dashboard from './admin/dashboard/dashboard';
import Employees from './admin/employees/employees';
import EmployeeDetails from './admin/employee-details/employee-details';
import Customers from './admin/customers/customers';
import CustomerDetails from './admin/customer-details/customer-details';
import Contracts from './admin/contracts/contracts';
import ContractDetails from './admin/contract-details/contract-details';
import Projects from './admin/projects/projects';
import ProjectDetails from './admin/project-details/project-details';
import Review from './review/review';
import ReviewTimesheetDetail from "./review/modals/timesheet-detail/timesheet-detail";
import Payroll from "./admin/payroll/payroll";
import PayrollDetails from "./admin/payroll-details/payroll-details";
import ChargeCodes from './admin/chargecodes/chargecodes';
import ChargeCodeDetails from './admin/chargecode-details/chargecode-details';
import Invoices from './admin/invoices/invoices';
import InvoiceCreate from './admin/invoice-create/invoice-create';
import InvoiceCreateWizard from './admin/invoice-create-wizard/invoice-create-wizard';
import InvoiceCreateTravel from './admin/invoice-create-travel/invoice-create-travel';
import InvoiceCreateOther from './admin/invoice-create-other/invoice-create-other';
import InvoiceDetails from './admin/invoice-details/invoice-details';
import Settings from './admin/settings/settings';
import ChargeCodeCreate from './admin/chargecode-create/chargecode-create';
import EmployeeCreate from './admin/employee-create/employee-create';
import Reports from './admin/reports/reports';
import Integrations from './admin/integrations/integrations';
import Expenses from './expenses/expenses';
import ExpenseReview from './admin/expense-review/expense-review';
import ExpenseImport from './admin/expense-import/expense-import';
import PerDiemRates from './admin/per-diem-rates/per-diem-rates';
import ExpenseReviewDetails from './admin/expense-review-details/expense-review-details';
import GeneralBusinessReviewDetails from './admin/general-business-review-details/general-business-review-details';
import OtherDirectCostsReviewDetails from './admin/other-direct-costs-review-details/other-direct-costs-review-details';
import RoleManagement from './admin/role-management/role-management';
import Unauthorized from "./403/unauthorized";
import CompanyBenefits from './admin/company-benefits/company-benefits';
import Leave from './leave/leave';
import Subcontractors from "./admin/subcontractors/subcontractors";
import SubcontractorDetails from "./admin/subcontract-details/subcontract-details";
import SubcontractDetails from './admin/subcontractor-details/subcontractor-details';
import Subcontracts from "./admin/subcontracts/subcontracts";
import DataManagement from "./admin/information-management/information-management";

let componentModule = angular.module('app.components', [
  Login.name,
  NotFound.name,
  Admin.name,
  InvoiceDetails.name,
  Dashboard.name,
  Employees.name,
  EmployeeDetails.name,
  Customers.name,
  CustomerDetails.name,
  Contracts.name,
  Profile.name,
  Payroll.name,
  PayrollDetails.name,
  ContractDetails.name,
  Projects.name,
  ProjectDetails.name,
  Review.name,
  ReviewTimesheetDetail.name,
  ChargeCodeDetails.name,
  Invoices.name,
  ChargeCodes.name,
  ChargeCodeDetails.name,
  InvoiceCreate.name,
  InvoiceCreateWizard.name,
  InvoiceCreateTravel.name,
  InvoiceCreateOther.name,
  Settings.name,
  ChargeCodeCreate.name,
  EmployeeCreate.name,
  Reports.name,
  Integrations.name,
  Expenses.name,
  ExpenseReview.name,
  ExpenseImport.name,
  PerDiemRates.name,
  ExpenseReviewDetails.name,
  GeneralBusinessReviewDetails.name,
  OtherDirectCostsReviewDetails.name,
  RoleManagement.name,
  Unauthorized.name,
  CompanyBenefits.name,
  Timesheet.name,
  Leave.name,
  Subcontractors.name,
  SubcontractorDetails.name,
  SubcontractDetails.name,
  Subcontracts.name,
  DataManagement.name
]);

export default componentModule;



// WEBPACK FOOTER //
// ./client/pages/components.js